import { render } from "./Applyhistory.vue?vue&type=template&id=25559538&scoped=true"
import script from "./Applyhistory.vue?vue&type=script&lang=js"
export * from "./Applyhistory.vue?vue&type=script&lang=js"

import "./Applyhistory.vue?vue&type=style&index=0&id=25559538&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-25559538"

export default script